<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label">{{ label }}</label>
    <div class="col-sm-8">
      <dataset-select :id="safeId()" v-model="localValue"></dataset-select>
      <small class="form-text text-muted" v-if="datasetColumns">{{ datasetColumns }}</small>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'dataset-select-group',
    props: {
      label: {default: 'Dataset'},
      value: {required: true},
      showFields: {default: false}
    },
    data () {
      return {
        localValue: this.value
      }
    },
    computed: {
      datasetColumns () {
        return this.$store.getters.datasetColumns(this.localValue).join(', ')
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.localValue = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/dataset-select-group.vue